import { lazyVue } from "@/utils";
export default [
  {
    path: "/scanResult",
    name: "scanResult",
    title: "",
    component: lazyVue("scanResult/index"),
    meta: {
      title: "",
      name: "scanResult",
      showBar: false,
      isKeepAlive: false
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/scanResult/index.js